import { FunctionComponent } from 'react';

export type SeparatorCurveProps = {
  width: number;
  height: number;
  fill: string;
};

type FC = FunctionComponent<SeparatorCurveProps>;

const SeparatorCurve: FC = (props: SeparatorCurveProps) => {
  const { width, height, fill } = props;

  return (
    <svg width={`${width}%`} height={`${height}%`} viewBox="0 0 622 924" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M622 -13L622 26.5487C622 65.0833 622 143.167 598.631 221.25C575.261 299.333 528.522 377.417 496.008 455.5C462.478 533.583 444.189 611.667 444.189 689.75C444.189 767.833 462.478 845.917 472.639 885.465L481.783 924L-179.5 924L-179.5 885.465C-179.5 845.917 -179.5 767.833 -179.5 689.75C-179.5 611.667 -179.5 533.583 -179.5 455.5C-179.5 377.417 -179.5 299.333 -179.5 221.25C-179.5 143.167 -179.5 65.0833 -179.5 26.5487L-179.5 -13L622 -13Z"
        fill={fill}
      />
    </svg>
  );
};

export default SeparatorCurve;
